export const MEAL_TIMES_OPTIONS = [
  { id: "desayuno", name: "Desayuno" },
  { id: "almuerzo", name: "Almuerzo" },
  { id: "merienda", name: "Merienda" },
  { id: "cena", name: "Cena" },
];
